export const INSTITUTE_DEFAULT_VALUE = {
  institute: {
    institute: "",
    error: false,
  },
  instituteName: {
    instituteName: "",
    id: "",
    error: false,
  },
  mobileNo: "",
  contactNo: {
    contactNo: "",
    error: false,
  },
  email: {
    email: "",
    error: false,
  },
  address1: "",
  address2: "",
  city: {
    city: "",
    error: false,
  },
  district: {
    district: "",
    error: false,
  },
  active: true,
  assignUser: { id: "", error: false },
};
